// extracted by mini-css-extract-plugin
export default {"banner":"shared-page_banner__LMffJ","storyBanner":"shared-page_storyBanner__9uXgT","bannerText":"shared-page_bannerText__QbTfJ"};